import { useState } from "react";
import { useTranslation } from "react-i18next";
import { categories } from "@/data/categories";

export default function CategoryDropdown() {
  const { t } = useTranslation();
  const [selected, setSelected] = useState<string>("");

  const handleChange = (url: string) => {
    if (!url) return;
    setSelected(url);
    window.open(url, "_blank", "noopener,noreferrer");
    setSelected("");
  };

  return (
    <div className="w-full max-w-md">
      <label className="mb-2 block text-sm font-semibold text-foreground-700">
        {t("dropdown.label")}
      </label>
      <select
        value={selected}
        onChange={(e) => handleChange(e.target.value)}
        className="w-full appearance-none rounded-md border border-background-200 bg-background-50 px-4 py-3 text-sm text-foreground-800 cursor-pointer outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
      >
        <option value="">{t("dropdown.placeholder")}</option>
        {categories.map((c) => (
          <option key={c.id} value={c.url}>
            {t(c.nameKey)}
          </option>
        ))}
      </select>
    </div>
  );
}